// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
*,
*::before,
*::after {
  box-sizing: border-box;
}
html,
body,
#app {
  height: 100%;
  height: 100dvh;
  height: -webkit-fill-available;
  margin: 0;
}
#app {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  background: #ededed;
  overflow: hidden;
}
button {
  cursor: pointer;
}
button:disabled {
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/App.vue"],"names":[],"mappings":";AASA;;;EAGE,sBAAsB;AACxB;AAEA;;;EAGE,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,SAAS;AACX;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE;cACY;EACZ,mCAAmC;EACnC,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["<script setup lang=\"ts\">\r\nimport { RouterView } from 'vue-router'\r\n</script>\r\n\r\n<template>\r\n  <RouterView />\r\n</template>\r\n\r\n<style>\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml,\r\nbody,\r\n#app {\r\n  height: 100%;\r\n  height: 100dvh;\r\n  height: -webkit-fill-available;\r\n  margin: 0;\r\n}\r\n\r\n#app {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n\r\nbody {\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -webkit-text-size-adjust: 100%;\r\n  background: #ededed;\r\n  overflow: hidden;\r\n}\r\n\r\nbutton {\r\n  cursor: pointer;\r\n}\r\n\r\nbutton:disabled {\r\n  cursor: not-allowed;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
